'use client';

import React from 'react';
import LoginForm from './LoginForm';
import Link from 'next/link';
import { useLanguage } from '@/contexts/LanguageContext';

const LoginInteractive = () => {
  const { t } = useLanguage();

  const handleLoginSuccess = (userData: { email: string; name: string }) => {
    console.log('Login successful:', userData);
  };

  return (
    <div className="space-y-6">
      <LoginForm onLoginSuccess={handleLoginSuccess} />
      
      {/* Admin Login Link */}
      <div className="text-center">
        <Link 
          href="/admin" 
          className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-premium font-medium"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
          </svg>
          <span>{t('تسجيل دخول شريك', 'Partner Login')}</span>
        </Link>
      </div>
    </div>
  );
};

export default LoginInteractive;